// @ts-ignore
import { trimMiddle as actualTrimMiddle } from "trimmiddle";
export default function trimMiddle(raw: string, maxLength: number, replacement = "...") {
  return actualTrimMiddle(raw, maxLength, replacement);
}
